import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';

/***
 * Logging user out from
 * all the tabs in session.
 */
window.addEventListener('storage', (event: StorageEvent) => {
  if (event.storageArea === localStorage) {
    if (event.key === 'user-custom-session' && event.newValue === null) {
      window.location.href = '/login';
      window.location.reload();
    }
    if (event.key === 'is-impersonating' && event.newValue === null) {
      window.location.href = '/profiles/people/home';
    }
    if (event.key === 'is-impersonating' && event.newValue === 'true') {
      window.location.href = '/welcome';
    }
  }
});

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
